import React, { createContext } from 'react';

const StructureContext = createContext({
  metadata: {},
  structure: null,
});

export const withStructureContext = (Component) => {
  function WithStructureContextHOC(props) {
    return (
      <StructureContext.Consumer>
        {({ metadata, structure }) => <Component {...props} metadata={metadata} structure={structure} />}
      </StructureContext.Consumer>
    );
  }
  return WithStructureContextHOC;
};

export default StructureContext;
